<app-enfaf-modal
  [title]="'GOD_ORDERS.LINK.TITLE' | translate"
  [subtitle]="
    'GOD_ORDERS.LINK.SUBTITLE' | translate: { order: data.purchase.orderNumber ? '#' + data.purchase.orderNumber : data.purchase.productName }
  "
  [buttonCancelText]="'GOD_ORDERS.LINK.CANCEL' | translate"
  [buttonConfirmText]="'GOD_ORDERS.LINK.CONFIRM' | translate"
  [disableConfirmButton]="!selected() || saving()"
  [isLoading]="saving()"
  [showCloseButton]="true"
  [compactContent]="true"
  (onClose)="close()"
  (onConfirm)="confirm()"
>
  <div class="link" data-testid="link-payment-modal">
    <enfaf-searchable-input
      color="light"
      [control]="searchControl"
      [isLoading]="loading()"
      [label]="'GOD_ORDERS.LINK.SEARCH_LABEL' | translate"
      [placeholder]="'GOD_ORDERS.LINK.SEARCH_PLACEHOLDER' | translate"
    />

    @if (loadFailed()) {
      <p class="link__state link__state--error">
        {{ 'GOD_ORDERS.LINK.LOAD_ERROR' | translate }}
        <button type="button" class="link__retry" (click)="retry()">{{ 'GOD_ORDERS.BREAKDOWN.RETRY' | translate }}</button>
      </p>
    } @else if (response(); as page) {
      @if (!page.data.length) {
        <p class="link__state" data-testid="link-empty">{{ (search() ? 'GOD_ORDERS.LINK.EMPTY_SEARCH' : 'GOD_ORDERS.LINK.EMPTY') | translate }}</p>
      } @else {
        <!-- Listbox (WAI-ARIA): one tab stop; ↑/↓, Inicio/Fin move between the payments and Enter / Espacio picks one. -->
        <ul
          #list
          class="link__list"
          role="listbox"
          data-testid="unlinked-payments"
          [attr.aria-label]="'GOD_ORDERS.LINK.LIST_ARIA' | translate"
          [class.link__list--loading]="loading()"
          (keydown)="onListKeydown($event, page.data)"
        >
          @for (payment of page.data; track payment.orderId; let index = $index) {
            <li
              class="link__item"
              role="option"
              data-testid="unlinked-payment"
              [id]="'unlinked-payment-' + payment.orderId"
              [class.link__item--selected]="payment.orderId === selectedId()"
              [attr.aria-selected]="payment.orderId === selectedId()"
              [attr.tabindex]="index === activeIndex(page.data) ? 0 : -1"
              (focus)="focusedIndex.set(index)"
              (click)="select(payment, index)"
            >
              <span class="link__order">
                <strong>#{{ payment.orderId }}</strong>
                <span>{{ formatShortDate(payment.date) }}</span>
              </span>
              <span class="link__student">
                <span class="link__student-name">{{ studentName(payment) }}</span>
                <span class="link__student-email">{{ payment.student.email }}</span>
              </span>
              <span class="link__product" [title]="payment.productName">{{ payment.productName }}</span>
              <app-payment-method-cell [method]="payment.paymentMethod" [cardBrand]="payment.cardBrand" />
              <strong class="link__amount">{{ formatEuros(payment.total) }}</strong>
            </li>
          }
        </ul>
        @if (page.totalPages > 1) {
          <enfaf-pagination color="light" [config]="paginationConfig()" (pageChange)="onPageChange($event)" />
        }
      }
    }

    @if (linkError(); as message) {
      <p class="link__error" role="alert" data-testid="link-error">{{ message }}</p>
    }
  </div>
</app-enfaf-modal>
